import MarketingRedirect from './marketing-redirect';
import {withPAR} from '../../../components/Timing';
import {connect} from 'react-redux';
import {compose} from 'redux';
import withTripboardQuery from './with-tripboard-query';
import {getTranslations} from '../../../selectors';
import {asyncComponent} from 'react-async-component';
import withTripboardListingDelete from './with-tripboard-listing-delete';
import tripboardActions from '../../actions';
import onboardingActions from '../../../components/onboarding/actions';

function mapStateToProps(state) {
    return {
        locale: state.system.locale,
        currency: state.system.currency,
        siteName: state.system.siteName,
        siteDisplayName: state.system.siteDisplayName,
        translations: getTranslations(state)
    };
}
const mapDispatchToProps = {
    setCurrentTripboard: tripboardActions.setCurrentTripboard,
    completeTripboardCreation: onboardingActions.completeTripboardCreation
};
const DetailsGraphqlContainer = compose(
    withPAR,
    connect(mapStateToProps, mapDispatchToProps),
    withTripboardQuery, // must come before withChangeTripboardDateRange and withDeleteTripboardDateRange
    withTripboardListingDelete
)(MarketingRedirect);

export default (asyncComponent({
    name: 'DetailsGraphqlContainer',
    resolve: () => Promise.resolve(DetailsGraphqlContainer), // connect HitPrice to abacus
    serverMode: 'defer'
}));



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/details-container.js